import mapFunction from './mapResources';

export default mapFunction('certifications', {
    isFetching: false,
    items: [] 
});